import baseAPI from "@/http";

const machineRouter = "api/ec2-codex";
const remoteRouter = "api/codex-remote";
// Preserve the browser's socket IP at Fly Proxy, bypassing the RJ CloudFront hop.
// Reuse the authenticated HTTP client/interceptors. No token enters a URL.
const manualRdpConfig = () => window.location.origin === "https://rj.cidadeempreendedora.com.br"
  ? { baseURL: "https://cidade-empreendedora-prd.fly.dev/" }
  : {};

export const ec2CodexAPI = {
  status: () => baseAPI.get(`${machineRouter}/status`),
  start: () => baseAPI.post(`${machineRouter}/start`),
  stop: () => baseAPI.post(`${machineRouter}/stop`),
  previewRdpAccess: (key, payload) => baseAPI.post(`${machineRouter}/machines/${encodeURIComponent(key)}/rdp-access/preview`, payload, manualRdpConfig()),
  confirmRdpAccess: (key, payload) => baseAPI.post(`${machineRouter}/machines/${encodeURIComponent(key)}/rdp-access/confirm`, payload, manualRdpConfig()),
  downloadRdp: () => baseAPI.get(`${machineRouter}/rdp`, { responseType: "blob" }),
  machineStatus: (key) => baseAPI.get(`${machineRouter}/machines/${encodeURIComponent(key)}/status`),
  machinePower: (key, action) => baseAPI.post(`${machineRouter}/machines/${encodeURIComponent(key)}/${action}`),
  machineRdp: (key) => baseAPI.get(`${machineRouter}/machines/${encodeURIComponent(key)}/rdp`, { responseType: "blob" }),
  hosts: () => baseAPI.get(`${remoteRouter}/hosts`),
  threads: (hostId) => baseAPI.get(`${remoteRouter}/hosts/${encodeURIComponent(hostId)}/threads`),
  commands: (hostId) => baseAPI.get(`${remoteRouter}/commands`, { params: { hostId } }),
  commandStatus: (commandId) => baseAPI.get(`${remoteRouter}/commands/${commandId}`),
  events: (commandId, afterId = 0) => baseAPI.get(`${remoteRouter}/commands/${commandId}/events`, { params: { afterId } }),
  prompt: (payload) => baseAPI.post(`${remoteRouter}/prompt`, payload),
  command: (payload) => baseAPI.post(`${remoteRouter}/command`, payload),
  uploadFile: (hostId, threadId, file) => {
    const form = new FormData();
    form.append("hostId", hostId);
    if (threadId) form.append("threadId", threadId);
    form.append("file", file);
    return baseAPI.post(`${remoteRouter}/files`, form);
  },
  files: (hostId, threadId, commandId) => baseAPI.get(`${remoteRouter}/files`, { params: { hostId, threadId, commandId } }),
  downloadFile: (id) => baseAPI.get(`${remoteRouter}/files/${encodeURIComponent(id)}`, { responseType: "blob" }),
  whatsAppEmbeddedSignup: () => baseAPI.get(`${remoteRouter}/whatsapp/embedded-signup`),
  completeWhatsAppEmbeddedSignup: (payload) => baseAPI.post(`${remoteRouter}/whatsapp/embedded-signup`, payload),
};
